"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductItemByHandle = void 0;
const useProductByHandle_1 = require("./useProductByHandle");
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    version: 'item',
    options: {},
};
const useProductItemByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { product: productItem, fetchProductByHandle, ...productByHandleStatus } = (0, useProductByHandle_1.useProductByHandle)(props);
    return {
        productItem,
        fetchProductItemByHandle: fetchProductByHandle,
        ...productByHandleStatus,
    };
};
exports.useProductItemByHandle = useProductItemByHandle;
//# sourceMappingURL=useProductItemByHandle.js.map